import { render, staticRenderFns } from "./NewProposalForm.vue?vue&type=template&id=dbe79b74&scoped=true&"
import script from "./NewProposalForm.vue?vue&type=script&lang=js&"
export * from "./NewProposalForm.vue?vue&type=script&lang=js&"
import style0 from "./NewProposalForm.vue?vue&type=style&index=0&id=dbe79b74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe79b74",
  null
  
)

export default component.exports